import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { FIRST_PAGE, MAX_PER_PAGE } from 'constants/constants';
import { ThreadMessagesArgs, ThreadPage } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import { buildQueryKey } from 'utils/buildQueryKey';
import clientUtil from 'utils/clientUtil';

type TData = ThreadPage;
type TVariables = ThreadMessagesArgs | { id?: string };

const MOCK: TVariables = {
  id: undefined,
  page: FIRST_PAGE,
  perPage: MAX_PER_PAGE,
  skipPagination: undefined
};

export const useUniversalChatThreadsContexts = (
  variables: TVariables = MOCK,
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query universalChatThreads($id: ID, $perPage: Int) {
      universalChatThreads(id: $id, perPage: $perPage) {
        nodes {
          contexts {
            uploadedFile {
              id
            }
          }
        }
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['useUniversalChatThreadsContexts', ...buildQueryKey({ ...MOCK, ...variables })],
    queryFn: async () =>
      client.request({
        data: {
          gql: graphql,
          variables
        }
      })
  });
};
